<template>
  <div class="widget-counter">
    <div class="widget-counter-header">
      <div class="title">{{ title }}</div>
      <!-- <a href="#" class="link" @click.prevent="onClick">View More</a> -->
    </div>
    <div class="widget-counter-body">
      <div class="counter-value" :style="{ fontSize: counterTextSize }">
        {{ value }}
      </div>
      <div class="counter-logo">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget-counter",
  props: {
    title: {
      type: String,
      default: "Title",
    },
    value: {
      type: [String, Number],
      default: 0,
    },
    counterTextSize: {
      type: String,
      default: "25px"
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() { },
  methods: {
    onClick(e) {
      let vm = this;
      vm.$emit("more", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.widget-counter {
  width: 100%;
  background: #feffff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dddddd;
  border-radius: 8px;
  height: 100%;

  .widget-counter-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .title {
      font-size: 18px;
      color: #5e6c84;
    }

    .link {
      color: #0065e1;
    }
  }

  .widget-counter-body {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .counter-value {
      display: flex;
      align-items: center;
      font-weight: 800;
    }
    .counter-logo {
      width: 120px;
    }
  }
}
</style>
